export enum ResultTabsetUrlsEnum {
    ADSINTEL = '/results/adsintel',
    AGENTIC_WORKFLOWS = '/results/gtmcanvas',
    BOUNCEINTEL = '/results/bounceintel',
    COMPANIES = '/results/companies',
    CONTACTS = '/results/contacts',
    CUSTOM_ENRICHMENT = '/results/custom-enrichment',
    DASHBOARD = '/results/dashboard',
    FORMSINTEL = '/results/forms-intel',
    ENRICHMENT = '/results/enrichment',
    INBOXINTEL = '/results/inboxintel',
    LISTS = '/results/lists',
    ICPINTEL = '/results/icp-intel',
    REPINTEL = '/results/rep-intel',
    ROD = '/results/rod',
    SAVEDSEARCHES = '/results/savedsearches',
    SEARCH = '/results/search',
    VISITORINTEL = '/results/visitorintel',
}
